const shadows = {
    0: 'none',
    xs: '0px 2px 4px rgba(51, 51, 51, 0.08)',
    s: '0px 4px 6px rgba(51, 51, 51, 0.1)',
    m: '0px 6px 8px rgba(51, 51, 51, 0.1)',
    l: '0px 8px 10px rgba(51, 51, 51, 0.1)',
    xl: '4px 10px 12px rgba(51, 51, 51, 0.08)',
};
export default shadows;
//# sourceMappingURL=shadows.js.map